import { Route, Routes } from '@angular/router';
import { ClaimsComponent } from './features/claims/claims.component';

export const routes: Array<Route> = [
  { path: '', redirectTo: 'claim-management', pathMatch: 'full' },
  { path: 'claim-management', component: ClaimsComponent, providers:[],runGuardsAndResolvers: 'always' },
  {
    path: '**',
    component: ClaimsComponent,
    data: { hidden: true },
  },
];
